"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constantizeGenderInRules = constantizeGenderInRules;
exports.inclineByRules = inclineByRules;
exports.findRule = findRule;
exports.findExactRule = findExactRule;
exports.applyRule = applyRule;
exports.applyMod = applyMod;
exports.getDeclensionConst = getDeclensionConst;
exports.getDeclensionStr = getDeclensionStr;
exports.PREPOSITIONAL = exports.INSTRUMENTAL = exports.ACCUSATIVE = exports.DATIVE = exports.GENITIVE = exports.NOMINATIVE = void 0;

var _utils = require("./utils");

var _gender = require("./gender");

/* eslint-disable no-use-before-define, no-continue, arrow-parens */
var NOMINATIVE = 1; // именительный

exports.NOMINATIVE = NOMINATIVE;
var GENITIVE = 2; // родительный

exports.GENITIVE = GENITIVE;
var DATIVE = 3; // дательный

exports.DATIVE = DATIVE;
var ACCUSATIVE = 4; // винительный

exports.ACCUSATIVE = ACCUSATIVE;
var INSTRUMENTAL = 5; // творительный

exports.INSTRUMENTAL = INSTRUMENTAL;
var PREPOSITIONAL = 6; // предложный

exports.PREPOSITIONAL = PREPOSITIONAL;

function constantizeGenderInRules(rules) {
  if (Array.isArray(rules.exceptions)) {
    rules.exceptions.forEach(function (rule) {
      rule.gender = (0, _gender.getGenderConst)(rule.gender); // eslint-disable-line
    });
  }

  if (Array.isArray(rules.suffixes)) {
    rules.suffixes.forEach(function (rule) {
      rule.gender = (0, _gender.getGenderConst)(rule.gender); // eslint-disable-line
    });
  }
}

function inclineByRules(str, declensionStr, genderStr, ruleSet) {
  var declension = getDeclensionConst(declensionStr);
  var gender = (0, _gender.getGenderConst)(genderStr);
  var parts = str.split('-');
  var result = [];

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];
    var isFirstWord = i === 0 && parts.length > 1;
    var rule = findRule(part, gender, ruleSet, {
      firstWord: isFirstWord
    });

    if (rule) {
      result.push(applyRule(rule, part, declension));
    } else {
      result.push(part);
    }
  }

  return result.join('-');
}

function findRule(str, gender, ruleSet) {
  var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!str) {
    return null;
  }

  var strLower = str.toLowerCase();
  var tagList = [];
  Object.keys(tags).forEach(function (key) {
    if (tags[key]) {
      tagList.push(key);
    }
  });

  if (ruleSet.exceptions) {
    var rule = findExactRule(ruleSet.exceptions, gender, function (some) {
      return some === strLower;
    }, tagList);
    if (rule) return rule;
  }

  return ruleSet.suffixes ? findExactRule(ruleSet.suffixes, gender, function (some) {
    return (0, _utils.endsWith)(strLower, some);
  }, tagList) : null;
}

function findExactRule(rules, gender, matchFn) {
  var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  for (var i = 0; i < rules.length; i++) {
    var rule = rules[i]; // rule with tag should be skipped if tag not listed in args

    if (rule.tags) {
      if (!rule.tags.find(function (t) {
        return tags.indexOf(t) !== -1;
      })) {
        continue;
      }
    } // rule must have same gender or be `androgynous`


    if (rule.gender !== _gender.ANDROGYNOUS && gender !== rule.gender) {
      continue;
    }

    if (rule.test) {
      for (var j = 0; j < rule.test.length; j++) {
        if (matchFn(rule.test[j])) {
          return rule;
        }
      }
    }
  }

  return null;
}

function getModByIdx(mods, i) {
  if (mods && mods.length >= i) {
    return mods[i];
  }

  return '.';
}

function applyRule(rule, str, declension) {
  var mod;

  switch (declension) {
    case NOMINATIVE:
      mod = '.';
      break;

    case GENITIVE:
      mod = getModByIdx(rule.mods, 0);
      break;

    case DATIVE:
      mod = getModByIdx(rule.mods, 1);
      break;

    case ACCUSATIVE:
      mod = getModByIdx(rule.mods, 2);
      break;

    case INSTRUMENTAL:
      mod = getModByIdx(rule.mods, 3);
      break;

    case PREPOSITIONAL:
      mod = getModByIdx(rule.mods, 4);
      break;

    default:
      mod = '.';
  }

  return applyMod(str, mod);
}

function applyMod(str, mod) {
  for (var i = 0; i < mod.length; i++) {
    var chr = mod[i];

    switch (chr) {
      case '.':
        break;

      case '-':
        str = str.substr(0, str.length - 1); // eslint-disable-line no-param-reassign

        break;

      default:
        str += chr;
      // eslint-disable-line no-param-reassign
    }
  }

  return str;
}

function getDeclensionConst(key) {
  switch (key) {
    case 'nominative':
    case NOMINATIVE:
      return NOMINATIVE;

    case 'genitive':
    case GENITIVE:
      return GENITIVE;

    case 'dative':
    case DATIVE:
      return DATIVE;

    case 'accusative':
    case ACCUSATIVE:
      return ACCUSATIVE;

    case 'instrumental':
    case INSTRUMENTAL:
      return INSTRUMENTAL;

    case 'prepositional':
    case PREPOSITIONAL:
      return PREPOSITIONAL;

    default:
      return null;
  }
}

function getDeclensionStr(cnst) {
  switch (cnst) {
    case 'nominative':
    case NOMINATIVE:
      return 'nominative';

    case 'genitive':
    case GENITIVE:
      return 'genitive';

    case 'dative':
    case DATIVE:
      return 'dative';

    case 'accusative':
    case ACCUSATIVE:
      return 'accusative';

    case 'instrumental':
    case INSTRUMENTAL:
      return 'instrumental';

    case 'prepositional':
    case PREPOSITIONAL:
      return 'prepositional';

    default:
      return null;
  }
}